<template>
  <ValidationObserver
    v-slot="{ handleSubmit, failed }"
    :class="{ updated }"
    class="updateable"
    tag="tr"
  >
    <td class="bold alignLower" v-if="archive">{{ product.turn }}</td>
    <td>
{{testovaciPromenna}}
      <select
        v-if="isTempProduct"
        v-model="form.productCategoryId"
        :disabled="!isTempProduct"
      >
        <option
          v-for="category in productCategories"
          :key="category.id"
          :value="category.id"
        >
          {{ category.name }}
        </option>
      </select>
      <div v-else-if="!archive" class="bold">
        {{ product.productCategory.name }}
      </div>
      <div v-else class="bold">
        {{ product.productDetail.productCategory.name }}
      </div>
    </td>
    <td>
      <ValidationProvider
        v-if="isTempProduct"
        rules="required"
        v-slot="{ failed }"
      >
        <input
          v-model="form.name"
          type="text"
          class="input-name-product"
          placeholder="Name of the product"
          :class="{ error: failed }"
          :disabled="!isTempProduct"
        />
      </ValidationProvider>
      <div v-else-if="!archive" class="bold">{{ product.name }}</div>
      <div v-else class="bold">{{ product.productDetail.name }}</div>
    </td>
    <td>
      <range-slider
        class="slider"
        min="0"
        max="100"
        :step="getStepCount()"
        v-model="form.quality"
        :disabled="!isEditing"
      >
      </range-slider>
    </td>
    <td v-if="!archive" class="bold alignLower">
      {{ productCost | ceilNumber | inCurrency }}
    </td>
    <td v-else class="bold alignLower">
      {{ product.cost | ceilNumber | inCurrency }}
    </td>
    <td class="buttons">
      <div v-if="isEditing" class="priceHelp">
        <div v-if="showHelp" class="priceHelp__tooltip">
          <div class="priceHelp__tooltip__left"></div>
          <div class="priceHelp__tooltip__right">
            We recommend that you enter a value that exceeds the cost.
          </div>
        </div>
        <div
          class="priceHelp__button"
          @mouseover="showHelp = true"
          @mouseleave="showHelp = false"
        ></div>
        <ValidationProvider rules="integer|required" v-slot="{ failed }">
          <input
            v-model.number="form.price"
            :class="{ error: failed }"
            type="number"
            class="priceHelp__input"
            placeholder="Set a selling price"
            title="Set a selling price"
            min="0"
            pattern="[0-9]"
          />
        </ValidationProvider>
      </div>
      <div v-else class="bold alignLower">
        {{ form.price | floorNumber | inCurrency }}
      </div>
      <div class="buttons">
        <template v-if="isEditing">
          <button
            class="confirmButton"
            :class="{ disabled: failed }"
            @click="handleSubmit(saveProduct)"
            title="Confirm"
          >
            Confirm
          </button>
          <button
            v-if="!isTempProduct"
            class="cancelButton"
            @click="cancelEditing"
            title="Cancel"
          >
            Cancel
          </button>
          <!-- <button
            v-if="!isTempProduct"
            style="position: relative;top: -8px;height: 28px;width: 30px;"
            @click="cancelEditing"
          >
            X
          </button>-->
        </template>
        <button
          v-else-if="!archive"
          class="editButton"
          @click="editProduct"
          title="Edit"
        >
          Edit
        </button>
        <!-- <div
           class="promoteButton"
           :class="{disabled: isEditing}"
           title="Promote"
         >Promote
         </div>-->
        <button
          v-if="product.removable !== false && !archive"
          class="deleteButton"
          @click="deleteProduct"
          title="Delete"
        >
          Delete
        </button>
      </div>
    </td>
  </ValidationObserver>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import RangeSlider from "vue-range-slider";
import updatableMixin from "../../../mixins/updatableMixin";
import "vue-range-slider/dist/vue-range-slider.css";

export default {
  name: "ProductRow",
  mixins: [updatableMixin],
  components: {
    RangeSlider,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    archive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: this.createForm(),
      showHelp: false,
      editPrice: false,
      editMode: false,
      archivedSlider: 63,
      testovaciPromenna: " "
    };
  },
  computed: {
    ...mapGetters(["productCategories", "me"]),
    productCategory() {
      return this.productCategories.find(
        (category) => category.id === this.form.productCategoryId
      );
    },
    productCost() {
      let cost = 0;
      if (this.product.productCategory) {
        let variableCost =
          this.product.productCategory.maxCost -
          this.product.productCategory.minCost;

          if(this.quality == 0.01){
            variableCost = 0;
          }
        cost =
          this.product.productCategory.minCost + variableCost * this.quality;
      }

      if (this.productCategory) {
        let variableCost =
          this.productCategory.maxCost - this.productCategory.minCost;
          if(this.quality == 0.01){
            variableCost = 0;
          }
        cost = this.productCategory.minCost + variableCost * this.quality;
      }

      return cost;
    },
    quality() {
      return this.form.quality / 100;
    },
    isEditing() {
      return this.isTempProduct || this.editMode;
    },
    isTempProduct() {
      return !this.product.id;
    },
    isFormEqual() {
      return _.isEqual(
        { ...this.form, quality: this.quality },
        {
          name: this.product.name,
          price: this.product.price,
          productCategoryId: this.product.productCategoryId,
          quality: this.product.quality,
        }
      );
    },
  },
  watch: {
    product: {
      deep: true,
      handler(product) {
        if (product.lastUserId !== this.me.id) {
          this.productUpdated();
        }
      },
    },
  },
  methods: {
    createForm() {
      return {
        quality: this.product.quality * 100,
        productCategoryId: this.product.productCategoryId,
        name: this.product.name,
        price: this.product.price,
      };
    },
    getStepCount(){
      var total  = 0
       if (this.product.productCategory) {
        total = this.product.productCategory.maxCost - this.product.productCategory.minCost + 1;
       }
        if (this.productCategory) {
        total = this.productCategory.maxCost - this.productCategory.minCost + 1;   
       }
      var steps = Math.ceil(100/total)
      return steps.toFixed(2)
    },
    async saveProduct() {
      if (!this.isTempProduct && this.isFormEqual) {
        this.editMode = false;
        return;
      }

      if(this.product.quality === 0){
        this.product.quality = 1;
      }
      if (this.form.price <= 100 && this.form.price > 0) {
        const newProduct = {
          ...(this.product.id
            ? {
                id: this.product.id,
                version: this.product.version,
              }
            : {}),
          ...this.form,
          quality: this.quality,
        };
        await this.$store.dispatch("toggleLoader", true);
        const result = await this.$store.dispatch("saveProduct", newProduct);
        if (result) {
          if (!this.product.id) {
            this.deleteProduct();
          }
        }

        this.editMode = false;
        await this.$store.dispatch("toggleLoader", false);
      } else {
        //cena je moc vysoká
        this.$toast.error(this.$t("messages.product.bad-price-range"));
      }
    },
    deleteProduct() {
      if (this.isTempProduct) {
        this.$emit("delete");
      } else {
        this.$store.dispatch("deleteProduct", this.product);
      }
    },
    editProduct() {
      this.editMode = true;
    },
    cancelEditing() {
      this.editMode = false;
      this.form = this.createForm();
    },
    productUpdated() {
      this.cancelEditing();
      this.triggerUpdatable();
    },
  },
};
</script>

<style>
</style>
